import { render } from "./DonationReceivalEventFormView.vue?vue&type=template&id=50b232aa&scoped=true"
import script from "./DonationReceivalEventFormView.vue?vue&type=script&lang=js"
export * from "./DonationReceivalEventFormView.vue?vue&type=script&lang=js"

import "./DonationReceivalEventFormView.vue?vue&type=style&index=0&id=50b232aa&lang=less&scoped=true"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b232aa"]])

export default __exports__